import type React from 'react';

import { clsx } from 'clsx';

import classes from '../Chat.module.scss';
import type { ChatRoomStatus } from '../api/routes';

interface ChatStatusTabsProps {
  value: ChatRoomStatus;
  onChange: (status: ChatRoomStatus) => void;
}

export const ChatStatusTabs: React.FC<ChatStatusTabsProps> = ({ value, onChange }) => {
  return (
    <div className={classes['chat-status-tabs']} role='tablist' aria-label='Фильтр чатов'>
      <button
        type='button'
        role='tab'
        aria-selected={value === 'active'}
        className={clsx(
          classes['chat-status-tab'],
          value === 'active' && classes['chat-status-tab--active'],
        )}
        onClick={() => onChange('active')}
      >
        Активные
      </button>
      <button
        type='button'
        role='tab'
        aria-selected={value === 'closed'}
        className={clsx(
          classes['chat-status-tab'],
          value === 'closed' && classes['chat-status-tab--active'],
        )}
        onClick={() => onChange('closed')}
      >
        Архив
      </button>
    </div>
  );
};
